<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <ng-container *ngIf="bookingDialogService.initialized">
                <ng-container *ngIf="!bookingDialogService.readonlyView; else showReadOnly">
                    <h2 mat-dialog-title class="title dialog-title m-0 p-0"><ng-container *ngIf="isNew; else editTitle">{{ 'dialogs.booking.titleCreate' | translate }}</ng-container><ng-template #editTitle><ng-container *ngIf="bookingDialogService.booking?.number as bookingNumber; else editTitleNoNumber">{{ (bookingDialogService.booking?.general?.bookingType === BookingType.Reservation ? 'dialogs.booking.titleEditReservationWithNumber' : 'dialogs.booking.titleEditBookingWithNumber') | translate: { number: bookingNumber } }}</ng-container><ng-template #editTitleNoNumber>{{ 'dialogs.booking.titleEdit' | translate }}</ng-template></ng-template></h2>
                </ng-container>
                <ng-template #showReadOnly>
                    <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'dialogs.booking.titleView' | translate }}<ng-container *ngIf="bookingDialogService.booking?.number"> - {{ bookingDialogService.booking.number }}</ng-container></h2>
                </ng-template>
            </ng-container>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <ng-container *ngIf="bookingDialogService.initialized; else loading">

        <div mat-dialog-content class="m-0 booking-dialog-content">

            <ng-container *ngIf="bookingDialogService.fromToChangedTenantRelation || bookingDialogService.fromToChangedPositions">
                <u2b-message type="warning">
                    {{ 'dialogs.booking.periodChangedWarning' | translate }}
                </u2b-message>
                <div class="from-to-changed-buttons">
                    <ng-container *ngIf="bookingDialogService.fromToChangedTenantRelation">
                        <button mat-raised-button color="accent"
                                (click)="updateTenantRelationDates()">
                            {{ 'dialogs.booking.applyTenantRelationDates' | translate }}
                        </button>
                    </ng-container>
                    <ng-container *ngIf="bookingDialogService.fromToChangedPositions">
                        <button mat-raised-button color="accent"
                                (click)="updatePositionsDates()">
                            {{ 'dialogs.booking.applyPositionsDates' | translate }}
                        </button>
                    </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="bookingDialogAppearance === BookingDialogAppearance.TABS; else useAccordion">
                <mat-tab-group [animationDuration]="0" [(selectedIndex)]="tabIndex">

                    <mat-tab [label]="'dialogs.booking.tabGeneral' | translate">
                        <booking-general-tab [bookingDialogFirstChoice]="bookingDialogFirstChoice">
                        </booking-general-tab>
                    </mat-tab>

                    <mat-tab [label]="'dialogs.booking.tabBerth' | translate">
                        <booking-berth-assignments-tab
                                [scrollOnCreate]="true">
                        </booking-berth-assignments-tab>
                    </mat-tab>

                    <mat-tab [label]="'dialogs.booking.tabTravelers' | translate">
                        <booking-travelers-tab>
                        </booking-travelers-tab>
                    </mat-tab>

                    <mat-tab [label]="'dialogs.booking.tabRelation' | translate">
                        <booking-tenant-relation-tab>
                        </booking-tenant-relation-tab>
                    </mat-tab>

                    <ng-container
                            *hasTenantPermission="bcmTenantPermissions.ELECTRIC_METERS">
                        <ng-container *hasPermission="permissionNames.ELECTRIC_METERS_READ">
                            <mat-tab [label]="'dialogs.booking.tabElectric' | translate">
                                <booking-electric-meters-tab>
                                </booking-electric-meters-tab>
                            </mat-tab>
                        </ng-container>
                    </ng-container>

                    <mat-tab [label]="'dialogs.booking.tabServices' | translate">
                        <booking-positions-tab>
                        </booking-positions-tab>
                    </mat-tab>

                    <mat-tab [label]="'dialogs.booking.tabDocuments' | translate">
                        <booking-documents-tab>
                        </booking-documents-tab>
                    </mat-tab>

                </mat-tab-group>
            </ng-container>

            <ng-template #useAccordion>
                <mat-accordion [multi]="true">

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabGeneral' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-general-tab [bookingDialogFirstChoice]="bookingDialogFirstChoice">
                        </booking-general-tab>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabBerth' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-berth-assignments-tab>
                            (boatEditModeEmitter)="boatEditMode = $event"
                        </booking-berth-assignments-tab>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabTravelers' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-travelers-tab>
                        </booking-travelers-tab>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabRelation' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-tenant-relation-tab>
                        </booking-tenant-relation-tab>
                    </mat-expansion-panel>

                    <ng-container
                            *hasTenantPermission="bcmTenantPermissions.ELECTRIC_METERS">
                        <ng-container *hasPermission="permissionNames.ELECTRIC_METERS_READ">
                            <mat-expansion-panel [expanded]="true">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>{{ 'dialogs.booking.tabElectric' | translate }}</mat-panel-title>
                                </mat-expansion-panel-header>
                                <booking-electric-meters-tab>
                                </booking-electric-meters-tab>
                            </mat-expansion-panel>
                        </ng-container>
                    </ng-container>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabCosts' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-positions-tab>
                        </booking-positions-tab>
                    </mat-expansion-panel>

                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ 'dialogs.booking.tabDocuments' | translate }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <booking-documents-tab>
                        </booking-documents-tab>
                        <ng-container *ngIf="!isNew">
                            <button data-test="B-Weiter" mat-flat-button
                                    color="accent"
                                    [disabled]="!bookingDialogService.initialized || isSaving || (!bookingDialogService.unsavedChanges && !isNew)"
                                    (click)="$event.stopPropagation(); save();">
                                <mat-icon>save</mat-icon>
                                <span>{{ 'dialogs.booking.saveInPanel' | translate }}</span>
                            </button>
                        </ng-container>
                    </mat-expansion-panel>

                </mat-accordion>
            </ng-template>

        </div>

        <div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">

            <ng-container *ngIf="!bookingDialogService.readonlyView; else showReadOnly">
                <div fxFlex="0 1 auto">
                    <ng-container *ngIf="bookingDialogService.unsavedChanges">
                        <button data-test="B-Abbrechen" mat-button
                                (click)="dialogRef.close(false)"
                                [attr.aria-label]="'common.closeDialogAria' | translate">
                            <mat-icon>cancel</mat-icon>
                            {{ 'common.cancel' | translate }}
                        </button>
                    </ng-container>
                </div>

                <div class="dialog-actions-buttons" fxFlex="0 1 auto" fxLayout="row" fxLayoutGap="1rem" fxLayoutGap.lt-sm="8px" fxLayoutAlign="end center">
                    <ng-template #saving>
                        <span>{{ 'dialogs.booking.saving' | translate }}</span>
                        <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                    </ng-template>

                    <ng-template #notSavingClose>
                        <span fxHide fxShow.gt-xs>{{ 'dialogs.booking.saveAndExit' | translate }}</span>
                    </ng-template>

                    <ng-container *ngIf="!isSaving">
                        <ng-container *ngIf="bookingDialogAppearance === BookingDialogAppearance.TABS">
                            <button data-test="B-Weiter" mat-flat-button
                                    color="accent"
                                    [disabled]="!bookingDialogService.initialized || isSaving"
                                    (click)="$event.stopPropagation(); nextTab();">
                                <mat-icon>arrow_forward</mat-icon>
                                <span fxHide fxShow.gt-xs>{{ 'dialogs.booking.next' | translate }}</span>
                            </button>
                        </ng-container>

                        <button data-test="B-Speichern" mat-flat-button
                                color="accent"
                                [disabled]="!bookingDialogService.initialized || isSaving || (!bookingDialogService.unsavedChanges && !(data.itemMoved || data.itemResized || data.cutEvent))"
                                (click)="$event.stopPropagation(); save(true);">
                            <mat-icon>save</mat-icon>
                            <span fxHide fxShow.gt-xs>{{ 'common.save' | translate }}</span>
                        </button>
                    </ng-container>

                    <ng-container
                            *ngIf="!bookingDialogService.unsavedChanges && !isSaving && !data.itemMoved && !data.itemResized && !data.cutEvent; else saveExitBtn">
                        <button data-test="B-Beenden" mat-flat-button
                                color="accent"
                                [disabled]="!bookingDialogService.initialized"
                                (click)="$event.stopPropagation(); dialogRef.close();">
                            {{ 'dialogs.booking.finish' | translate }}
                        </button>
                    </ng-container>
                    <ng-template #saveExitBtn>
                        <button data-test="B-Speichern und Beenden" mat-flat-button
                                color="accent"
                                [disabled]="!bookingDialogService.initialized || isSaving || (!bookingDialogService.unsavedChanges && !(data.itemMoved || data.itemResized || data.cutEvent))"
                                (click)="$event.stopPropagation(); save();">
                            <mat-icon>save</mat-icon>
                            <ng-container *ngIf="isSaving; then saving else notSavingClose"></ng-container>
                        </button>
                    </ng-template>

                </div>

            </ng-container>

            <ng-template #showReadOnly>
                <div></div>
                <div>
                    <ng-container *ngIf="bookingDialogAppearance === BookingDialogAppearance.TABS">
                        <button data-test="B-Weiter" mat-flat-button
                                color="accent"
                                [disabled]="!bookingDialogService.initialized || isSaving"
                                (click)="$event.stopPropagation(); nextTab();">
                            <mat-icon>arrow_forward</mat-icon>
                            <span fxHide fxShow.gt-xs>{{ 'dialogs.booking.next' | translate }}</span>
                        </button>
                    </ng-container>

                    <button data-test="B-Beenden" mat-flat-button
                            color="accent"
                            [disabled]="!bookingDialogService.initialized"
                            (click)="$event.stopPropagation(); dialogRef.close();">
                        {{ 'dialogs.booking.finish' | translate }}
                    </button>
                </div>
            </ng-template>

        </div>

    </ng-container>

    <ng-template #loading>
        <div class="loading">
            <mat-spinner></mat-spinner>
        </div>
    </ng-template>

</div>
